// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 数据存储
import store from './store'
// UI
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

import axios from 'axios';
import VueAxios from 'vue-axios';
import globalVariable from './global/constant';

// 解决双击菜单是控制台弹出报错信息的问题
import Router from 'vue-router';

// 接口请求地址
axios.defaults.baseURL = globalVariable.baseUrl;
// 设置跨域请求
axios.defaults.crossDomain = true;
// 允许携带cookie信息
axios.defaults.withCredentials = true;
// 设置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.config.productionTip = false
// 使用axios
Vue.use(VueAxios, axios);

Vue.config.productionTip = false
Vue.use(Element)
/* eslint-disable no-new */

// 使用全局常量
Vue.prototype.GLOBAL = globalVariable;
// 引入loding
Vue.prototype.bus = new Vue;

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

// 解决双击菜单是控制台弹出报错信息的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/main.js